<template>
  <div>
    <b-card no-body class="rounded-xl border-none">
      <div class="mt-8">
        <b-input-group>
          <b-form-input
            class="border-none shadow-lg"
            type="text"
            min="0.00"
            placeholder="Enter Search...."
          ></b-form-input>

          <b-input-group-append>
            <b-button
              variant="white"
              class="flex items-center shadow-lg"
              aria-label="search"
            >
              <feather-icon
                class="cursor-pointer mr-2"
                icon="SearchIcon"
                svgClasses="w-4 h-4"
              ></feather-icon>
            </b-button>
          </b-input-group-append>
        </b-input-group>
        <el-table
          class="table-responsive table-flush mt-6"
          header-row-class-name="thead-light table-th-color"
          :data="ShortcodeData"
        >
          <el-table-column
            label="ShortCode"
            min-width="120px"
            prop="shortCode"
            sortable
          >
            <template v-slot="{ row }">
              <span class="text-black font-medium">{{ row.shortCode }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="Keywords"
            min-width="140px"
            prop="keyword"
            sortable
          >
            <template v-slot="{ row }">
              <span class="text-black font-medium">{{ row.keyword }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="Sub Keywords"
            min-width="180px"
            prop="subkeywords"
            sortable
          >
            <template v-slot="{ row }">
              <span class="text-black font-medium">{{ row.subkeywords }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="Mobile"
            min-width="140px"
            prop="mobile"
            sortable
          >
            <template v-slot="{ row }">
              <span class="text-black font-medium">{{ row.mobile }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="Received_time"
            min-width="140px"
            prop="received"
            sortable
          >
            <template v-slot="{ row }">
              <span class="text-black font-medium">{{ row.received }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="Reply"
            min-width="140px"
            prop="reply"
            sortable
          >
            <template v-slot="{ row }">
              <span class="text-black font-medium">{{ row.reply }}</span>
            </template>
          </el-table-column>
        </el-table>

        <b-card-footer class="py-4 d-flex justify-content-end">
          <base-pagination
            v-model="currentPage"
            :per-page="10"
            :total="50"
          ></base-pagination>
        </b-card-footer>
      </div>
    </b-card>
  </div>
</template>
<script>
import ShortcodeData from "./ShortcodeData";

import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";
export default {
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  },
  data() {
    return {
      ShortcodeData,
      currentPage: 1,
      isDetailsActive: false,
      isShowCreate: false,
    };
  },
  methods: {
    toggleDetails(val = false) {
      this.isDetailsActive = val;
    },
  },
};
</script>
